module.exports = __webpack_public_path__ + "static/media/mark_verde.a8e5b9aa.svg";